import { Component, input } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { ImageUrlPipe } from '@pipes/image-url.pipe';

@Component({
  selector: 'art-bordered-image',
  imports: [ImageUrlPipe],
  providers: [provideTranslocoScope('dropzone')],
  templateUrl: './bordered-image.component.html',
  styleUrl: './bordered-image.component.scss',
  standalone: true,
})
export class BorderedImageComponent {
  uploadedImageUrl = input<string | null>(null);
  altText = input<string | null>(null);
}
